var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#65D8E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 13.7563H18.75C15.3 13.7563 12.5 16.5438 12.5 19.9813V27.4563V28.7063C12.5 32.1438 15.3 34.9313 18.75 34.9313H20.625C20.9625 34.9313 21.4125 35.1563 21.625 35.4313L23.5 37.9188C24.325 39.0188 25.675 39.0188 26.5 37.9188L28.375 35.4313C28.6125 35.1188 28.9875 34.9313 29.375 34.9313H31.25C34.7 34.9313 37.5 32.1438 37.5 28.7063V19.9813C37.5 16.5438 34.7 13.7563 31.25 13.7563ZM20 26.2563C19.3 26.2563 18.75 25.6938 18.75 25.0063C18.75 24.3188 19.3125 23.7563 20 23.7563C20.6875 23.7563 21.25 24.3188 21.25 25.0063C21.25 25.6938 20.7 26.2563 20 26.2563ZM25 26.2563C24.3 26.2563 23.75 25.6938 23.75 25.0063C23.75 24.3188 24.3125 23.7563 25 23.7563C25.6875 23.7563 26.25 24.3188 26.25 25.0063C26.25 25.6938 25.7 26.2563 25 26.2563ZM30 26.2563C29.3 26.2563 28.75 25.6938 28.75 25.0063C28.75 24.3188 29.3125 23.7563 30 23.7563C30.6875 23.7563 31.25 24.3188 31.25 25.0063C31.25 25.6938 30.7 26.2563 30 26.2563Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChats);
export default __webpack_public_path__ + "static/media/icon_chats.5329465b5b345f2cfa97680490d50f4c.svg";
export { ForwardRef as ReactComponent };